import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { LanguageProvider } from './contexts/LanguageContext';

// import pages
import Terms from './pages/terms.tsx';
import Privacy from './pages/privacy';
import CommunityGuidelines from './pages/guidelines';
import Safety from './pages/safety';
import DeleteUser from './pages/deleteuser';
import CityPlanes from './pages/CityPlanes';
import PlaneDetail from './pages/PlaneDetail';
import Ciudades from './pages/Ciudades';
import HomeRedesign from './pages/home-redesign/HomeRedesign';
import AppLinks from './pages/AppLinks';
import ChismePageLayout from './components/ChismePageLayout';
import PartnersPage from './pages/partners/PartnersPage';
import { PartnerPortalLoginRoutes, PartnerPortalPanelRoutes } from './pages/partners/portal/PartnerPortalRoutes';
import { getCityPlanes, getPlanBySlug } from './api/client';

function RedirectOldPlanesList() {
  const { city } = useParams();
  return <Navigate to={`/ciudades/${city}`} replace />;
}

/** /planes/:city/:planeId → /{slug} */
function RedirectOldPlanesDetail() {
  const { city, planeId } = useParams();
  const [slug, setSlug] = useState(undefined);
  const [done, setDone] = useState(false);

  useEffect(() => {
    let active = true;
    const citySlug = city ?? '';
    const legacyId = planeId ?? '';

    if (!legacyId || !citySlug) {
      setDone(true);
      return;
    }

    Promise.allSettled([getPlanBySlug(legacyId), getCityPlanes(citySlug)])
      .then((results) => {
        if (!active) return;

        const bySlug = results[0].status === 'fulfilled' ? results[0].value.plan.slug : null;
        const byLegacyId = results[1].status === 'fulfilled'
          ? results[1].value.planes.find((plan) => plan.id === legacyId)?.slug ?? null
          : null;

        setSlug(byLegacyId ?? bySlug ?? null);
      })
      .finally(() => {
        if (active) {
          setDone(true);
        }
      });

    return () => {
      active = false;
    };
  }, [city, planeId]);

  if (!done) {
    return null;
  }
  if (!slug) {
    return <Navigate to={`/ciudades/${city}`} replace />;
  }
  return <Navigate to={`/${slug}`} replace />;
}

/** /ciudades/:city/:planeId → /{slug} */
function RedirectCiudadesLegacyPlaneDetail() {
  const { city, planeId } = useParams();
  const [slug, setSlug] = useState(undefined);
  const [done, setDone] = useState(false);

  useEffect(() => {
    let active = true;
    const citySlug = city ?? '';
    const legacyId = planeId ?? '';

    if (!legacyId || !citySlug) {
      setDone(true);
      return;
    }

    Promise.allSettled([getPlanBySlug(legacyId), getCityPlanes(citySlug)])
      .then((results) => {
        if (!active) return;

        const bySlug = results[0].status === 'fulfilled' ? results[0].value.plan.slug : null;
        const byLegacyId = results[1].status === 'fulfilled'
          ? results[1].value.planes.find((plan) => plan.id === legacyId)?.slug ?? null
          : null;

        setSlug(byLegacyId ?? bySlug ?? null);
      })
      .finally(() => {
        if (active) {
          setDone(true);
        }
      });

    return () => {
      active = false;
    };
  }, [city, planeId]);

  if (!done) {
    return null;
  }
  if (!slug) {
    return <Navigate to={`/ciudades/${city}`} replace />;
  }
  return <Navigate to={`/${slug}`} replace />;
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/app" element={<AppLinks />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/partners/registro" element={<PartnerPortalLoginRoutes />} />
          <Route path="/partners/panel/*" element={<PartnerPortalPanelRoutes />} />
          <Route path="/partners/*" element={<Navigate to="/partners/registro" replace />} />
          <Route element={<ChismePageLayout />}>
            <Route path="/" element={<HomeRedesign />} />
            <Route path="/ciudades" element={<Ciudades />} />
            <Route path="/ciudades/:city/:planeId" element={<RedirectCiudadesLegacyPlaneDetail />} />
            <Route path="/ciudades/:city" element={<CityPlanes />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/guidelines" element={<CommunityGuidelines />} />
            <Route path="/safety" element={<Safety />} />
            <Route path="/:planSlug" element={<PlaneDetail />} />
          </Route>
          <Route path="/home-preview" element={<Navigate to="/" replace />} />
          <Route path="/deleteuser" element={<DeleteUser />} />
          <Route path="/planes/:city/:planeId" element={<RedirectOldPlanesDetail />} />
          <Route path="/planes/:city" element={<RedirectOldPlanesList />} />
          <Route path="/planes" element={<Navigate to="/ciudades" replace />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
